import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo4_Rodrigo } from '../../../../../utils/ES/Modals/directors';

const ModalVideoRodrigo4 = () => {
  return (
    <>
      <ModalVideo
        id="rodrigo-video-4"
        dataText={TextVideo4_Rodrigo}
        videoSrc="https://player.vimeo.com/video/252734087?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_RODRIGO_4"
      />
    </>
  );
};

export default ModalVideoRodrigo4;
